import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('incorrect_name'),
    description: defineMessage('the_details_you_entered_re_you_want_to_continue'),
    providedName: defineMessage('provided_details'),
    suggestedName: defineMessage('suggested_details'),
    name: defineMessage('name'),
    back: defineMessage('back'),
    confirm: defineMessage('confirm'),
};
